function Credits() {
  return (
    <>
      <div className="title">Credits</div>
      <hr></hr>
      <div className="para">
        <a href="https://www.youtube.com/watch?v=pFXYym4Wbkc">
          -Youtube tutorial by Clément Mihailescu.
        </a>
      </div>

      <div className="para">
        <a href="https://en.wikipedia.org/wiki/Merge_sort">
          -Merge sort Wikipedia.
        </a>
      </div>

      <div className="para">
        <a href="https://en.wikipedia.org/wiki/Bubble_sort">
          -Bubble sort Wikipedia.
        </a>
      </div>

      <div className="para">
        <a href="https://en.wikipedia.org/wiki/Quicksort">
          -Quick sort Wikipedia.
        </a>
      </div>

      <div className="para">
        <a href="https://en.wikipedia.org/wiki/Selection_sort">
          -Selection sort Wikipedia.
        </a>
      </div>

      <div className="para">
        <a href="https://en.wikipedia.org/wiki/Insertion_sort">
          -Insertion sort Wikipedia.
        </a>
      </div>

      <div className="para">
        <a href="https://www.geeksforgeeks.org/bubble-sort-algorithms-by-using-javascript/">
          -Bubble sort in Geeksforgeeks.
        </a>
      </div>

      <div className="para">
        <a href="https://stackabuse.com/quicksort-in-javascript/">
          -Quick sort in Stackabuse.
        </a>
      </div>

      <div className="para">
        <a href="https://stackabuse.com/selection-sort-in-javascript/">
          -Selection sort in Stackabuse.
        </a>
      </div>

      <div className="para">
        <a href="https://stackabuse.com/insertion-sort-in-javascript/">
          -Insertion sort in Stackabuse.
        </a>
      </div>

      <div className="para">
        <a href="https://www.youtube.com/watch?v=4VqmGXwpLqc">
          -Youtube video on Merge sort.
        </a>
      </div>

      <div className="para">
        <a href="https://www.youtube.com/watch?v=xli_FI7CuzA&t=57s">
          -Youtube video on Bubble sort.
        </a>
      </div>

      <div className="para">
        <a href="https://www.youtube.com/watch?v=Hoixgm4-P4M&t=130s">
          -Youtube video on Quick sort.
        </a>
      </div>

      <div className="para">
        <a href="https://www.youtube.com/watch?v=g-PGLbMth_g">
          -Youtube video on Selection sort.
        </a>
      </div>

      <div className="para">
        <a href="https://www.youtube.com/watch?v=JU767SDMDvA">
          -Youtube video on Insertion sort.
        </a>
      </div>

      <div className="para">
        <a href="https://www.creative-tim.com/">
          -Bootstrap react template downloaded from creative-tim.
        </a>
      </div>
    </>
  );
}

export default Credits;
